'use client'
import { SbBlokData, storyblokEditable, StoryblokServerComponent } from '@storyblok/react/rsc'
import { FC, useEffect, useState } from 'react'

import { PhnxAlert } from '@/components/01-atoms/Alert/Alert'

export interface PageSchema extends SbBlokData {
  header: any
  body: any
  page_availability: any
  alert_bar: any
}

interface PageProps {
  blok: PageSchema
  rels: any
  name: string
  currentSiteRoot: string
  locale?: string
  activeLocale?: string
  regional?: string
  isInsideStoryblok?: boolean
}

const Page: FC<PageProps> = ({ blok, rels, isInsideStoryblok, name }) => {
  const [keyword, setKeyword] = useState<string>('Wealth Management')

  useEffect(() => {
    // Check if window is defined to avoid errors during SSR
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search)
      const urlPath = window.location.pathname

      const businessConsultation = '/free-business-consultation'
      const wealthManagement = '/wealth-management-action-plan'

      const hkeyword = urlParams.get('h')
      const geokeyword = urlParams.get('geo')

      if (!hkeyword) {
        // No h parameter in URL
        if (urlPath === businessConsultation) {
          setKeyword('Business Advisory')
        } else if (urlPath === wealthManagement) {
          geokeyword && geokeyword !== ''
            ? setKeyword('Wealth Management near me')
            : setKeyword('Wealth Management')
        }
      } else if (urlPath === wealthManagement) {
        switch (hkeyword) {
          case '1':
            geokeyword && geokeyword !== ''
              ? setKeyword('Financial Advisor near me')
              : setKeyword('Financial Advisor')
            break
          case '2':
            geokeyword && geokeyword !== ''
              ? setKeyword('Investment near me')
              : setKeyword('Investment')
            break
          case '3':
            geokeyword && geokeyword !== ''
              ? setKeyword('Retirement near me')
              : setKeyword('Retirement')
            break
          case '4':
            geokeyword && geokeyword !== ''
              ? setKeyword('Superannuation near me')
              : setKeyword('Superannuation')
            break
          default:
            geokeyword && geokeyword !== ''
              ? setKeyword('Wealth Management near me')
              : setKeyword('Wealth Management')
            break
        }
      } else if (urlPath === businessConsultation) {
        switch (hkeyword) {
          case '1':
            setKeyword('Business Accounting')
            break
          case '2':
            setKeyword('Virtual/ Outsourced CFO')
            break
          case '3':
            setKeyword('Payroll Services')
            break
          case '4':
            setKeyword('Accounting Software')
            break
          case '5':
            setKeyword('Payroll Software')
            break
          case '6':
            setKeyword('Business Software')
            break
          default:
            setKeyword('Business Advisory')
            break
        }
      }
    }
  }, [])

  return (
    <div {...storyblokEditable(blok)}>
      {blok.alert_bar && blok.alert_bar[0] && (
        <PhnxAlert
          content={blok.alert_bar.map((nestedBlok: SbBlokData) => (
            <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))}
        />
      )}
      {!blok.header || (blok.header.length === 0 && <h1 className={'sr-only'}>{name}</h1>)}
      {blok.header &&
        blok.header.map((nestedBlok: SbBlokData, index: number) => {
          const dynamicDisplay = nestedBlok?.dynamicDisplay as string

          return keyword && dynamicDisplay ? (
            dynamicDisplay?.toLowerCase() === keyword.toLowerCase() ? (
              <StoryblokServerComponent
                blok={nestedBlok}
                key={nestedBlok._uid}
                rels={rels}
                isInsideStoryblok={isInsideStoryblok}
              />
            ) : null
          ) : (
            // if no keyword, only display the first header in the array
            index === 0 && (
              <StoryblokServerComponent
                blok={nestedBlok}
                key={nestedBlok._uid}
                rels={rels}
                isInsideStoryblok={isInsideStoryblok}
              />
            )
          )
        })}
      {blok.body &&
        blok.body.map((nestedBlok: SbBlokData) => (
          <StoryblokServerComponent
            blok={nestedBlok}
            key={nestedBlok._uid}
            rels={rels}
            isInsideStoryblok={isInsideStoryblok}
          />
        ))}
    </div>
  )
}

export default Page
